<template lang="pug">
.v-rates-layout.rates-layout
	.rates-layout__inner
		.rates-layout__main
			slot
		.rates-layout__converter
			v-panel(v-if="isTablet" :open-state="openConverter" :body-class="'rates-layout__panel'" :close-text="closeText")
				template(#btn)
					button.btn.btn--stroke.rates-layout__converter-btn
						img.btn__icon(v-if="button" :src="button?.icon")
						| {{button?.text}}
				template(#content)
					slot(name="converter")
			slot(v-else="" name="converter")
	.rates-layout__action
		slot(name="action")
</template>

<script>

import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		isMobMixin
	],

	props: {
		button: {
			type: Object,
			default: null
		},

		closeText: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			openConverter: true
		}
	}
}

</script>